import React from "react";
import { useParams, useNavigate } from "react-router-dom";

function CleaningListingActivationSuccess() {
  const { listingId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={container}>
      <div style={card}>
        <div style={icon}>✔️</div>

        <h2 style={title}>Cleaning Listing Activated</h2>

        <p style={text}>
          Your cleaning listing has been successfully activated and is now
          visible to buyers.
        </p>

        {/* WHAT HAPPENS NEXT */}
        <div
          style={{
            marginTop: "20px",
            padding: "16px",
            backgroundColor: "#f1f8e9",
            border: "1px solid #c5e1a5",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <h3 style={{ marginTop: 0, color: "#2e7d32" }}>
            What happens next?
          </h3>

          <ul style={{ margin: "10px 0 0 18px", lineHeight: "1.6" }}>
            <li>
              Your cleaning listing is now <strong>live</strong> and visible to buyers.
            </li>
            <li>
              Interested buyers can view your listing and proceed to purchase.
            </li>
            <li>
              If a buyer starts a purchase, your listing will be temporarily locked.
            </li>
            <li>
              You’ll be notified when there is activity on your listing.
            </li>
          </ul>
        </div>

        <div style={listingBox}>
          <strong>Listing ID:</strong> {listingId}
        </div>

        <div style={buttonRow}>
          <button
            style={primaryBtn}
            onClick={() => navigate(`/cleaning/listing/${listingId}`)}
          >
            View Listing
          </button>

          <button
            style={secondaryBtn}
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  display: "flex",
  justifyContent: "center",
  marginTop: "80px",
};

const card = {
  background: "#fff",
  padding: "40px",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  maxWidth: "500px",
  width: "100%",
  textAlign: "center",
};

const icon = {
  fontSize: "48px",
  marginBottom: "10px",
};

const title = {
  color: "#2e7d32",
  marginBottom: "15px",
};

const text = {
  color: "#444",
  marginBottom: "20px",
};

const listingBox = {
  background: "#f1f8f4",
  padding: "12px",
  borderRadius: "6px",
  margin: "25px 0",
};

const buttonRow = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
};

const primaryBtn = {
  padding: "12px 18px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

const secondaryBtn = {
  padding: "12px 18px",
  backgroundColor: "#1976d2",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default CleaningListingActivationSuccess;
